module.exports = __webpack_public_path__ + "static/media/tallaght.e9db843f.png";